import { render, staticRenderFns } from "./OrderProduct.vue?vue&type=template&id=18b801c0&"
import script from "./OrderProduct.vue?vue&type=script&lang=js&"
export * from "./OrderProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports